import BoardOrLoopPreviewController from 'webapp/controllers/boards/board-or-loop-preview';

import type BoardLoop from 'webapp/models-custom/board-loop';

export default class BoardsLoopsLoopController extends BoardOrLoopPreviewController {
	declare model: BoardLoop;
	showBottomSlider = true;
	rootUrlWithoutId = '/databoards/loops';

	get initialBoardId() {
		return this.previewUrlManager?.itemIdParam;
	}
}
